/* tslint:disable */
/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { Vaccination } from '../../models/vaccination';
import { VaccinationDto } from '../../models/vaccination-dto';

export interface AddVaccination$Params {
      body: VaccinationDto
}

export function addVaccination(http: HttpClient, rootUrl: string, params: AddVaccination$Params, context?: HttpContext): Observable<StrictHttpResponse<Vaccination>> {
  const rb = new RequestBuilder(rootUrl, addVaccination.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<Vaccination>;
    })
  );
}

addVaccination.PATH = '/api/vaccination';
